import Phaser from 'phaser';

/**
 * Responsive viewport helpers. The game runs in Scale.RESIZE mode (canvas fills the
 * screen), so scenes must lay out against the *actual* size — never fixed constants.
 * A reference height keeps font/spacing scale consistent across phones and desktops.
 */
export const REF_H = 720;

export interface Viewport {
  w: number;
  h: number;
  cx: number;
  cy: number;
  /** Uniform UI scale relative to the reference height (clamped for sanity). */
  s: number;
}

export function viewport(scene: Phaser.Scene): Viewport {
  const w = scene.scale.width;
  const h = scene.scale.height;
  return { w, h, cx: w / 2, cy: h / 2, s: Phaser.Math.Clamp(h / REF_H, 0.6, 1.6) };
}

/** Re-run a scene's layout whenever the canvas size changes; auto-cleans on shutdown. */
export function onResize(scene: Phaser.Scene, handler: () => void): void {
  scene.scale.on(Phaser.Scale.Events.RESIZE, handler);
  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => scene.scale.off(Phaser.Scale.Events.RESIZE, handler));
}
